import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import classNames from 'classnames'
import green from '@material-ui/core/colors/green'
import DeleteIcon from '@material-ui/icons/Delete'
import Snackbar from '@material-ui/core/Snackbar'
import { withStyles } from '@material-ui/core/styles'

import apiService from '../../../services/Api'

const styles = (theme: any) => ({
  button: {
    margin: theme.spacing.unit,
  },
  buttonSuccess: {
    margin: theme.spacing.unit,
    '&:hover': {
      backgroundColor: green[700],
    }
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  }
})

export interface DeleteKeyProps {
  keyId: string
  keyName: string
  userId: string
  apiId: string
  open: boolean
  onClose: () => void
  classes: any
}

export interface DeleteKeyState {
  open: boolean
  openSnackbar: boolean
  loading: boolean
  success: boolean
}

class DeleteKey extends React.Component<DeleteKeyProps, DeleteKeyState> {

  constructor(props: DeleteKeyProps) {
    super(props)
    this.state = {
      open: props.open,
      success: false,
      loading: false,
      openSnackbar: false
    }
    this.handleDelete = this.handleDelete.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this)
  }

  componentDidUpdate(prevProps: DeleteKeyProps) {
    if (this.props.open !== prevProps.open) {
      this.setState((state, props) => ({
        open: props.open
      }))
    }
  }

  handleCancel(): void {
    this.props.onClose()
    this.setState({
      open: false
    })
  }

  handleCloseSnackbar(event: any, reason: string): void {
    this.setState({ openSnackbar: false });
  }

  async handleDelete(): Promise<void> {
    const { keyId, userId, apiId } = this.props
    this.setState({
      loading: true
    })
    await new apiService().deleteKey(apiId, keyId, userId)
    this.setState({
      loading: false,
      success: true,
      open: false,
      openSnackbar: true
    })
    this.props.onClose()
  }

  render() {
    const { classes, keyName } = this.props
    const { loading, success, open, openSnackbar } = this.state
    const buttonClassname = classNames({
      [classes.buttonSuccess]: success,
    })

    return (
      <div>
        <Dialog open={open} aria-labelledby="Delete key">
          <DialogTitle id="simple-dialog-title">Delete key</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete key : <strong>{keyName}</strong> ?
            <br />
              You will not be able to use it anymore
          </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDelete} variant="contained" color="secondary" disabled={loading} className={buttonClassname}>
              Delete
          <DeleteIcon className={classes.rightIcon} />
              {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Button>
            <Button onClick={this.handleCancel} className={classes.button}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={openSnackbar}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Successfully deleted</span>}
          autoHideDuration={3000}
          onClose={this.handleCloseSnackbar}
        />
      </div>
    )
  }
}

export default withStyles(styles)(DeleteKey)
